import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["method", "action", "target"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "book-button full-width" }
const _hoisted_7 = { class: "book-button" }
const _hoisted_8 = { class: "alert-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDropdown = _resolveComponent("BaseDropdown")!
  const _component_QuickformPassengers = _resolveComponent("QuickformPassengers")!
  const _component_QuickformCalendar = _resolveComponent("QuickformCalendar")!
  const _component_QuickformDiscount = _resolveComponent("QuickformDiscount")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "quickform-form",
      onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
      method: _ctx.isExternal ? 'get' : 'post',
      action: _ctx.quickformAction,
      ref: "quickformRef",
      target: _ctx.isExternal ? '_blank' : '_self'
    }, [
      _cache[15] || (_cache[15] = _createElementVNode("input", {
        type: "hidden",
        name: "step",
        value: "2"
      }, null, -1)),
      _createElementVNode("input", {
        type: "hidden",
        name: "outwardDate",
        value: _ctx.outwardDate
      }, null, 8, _hoisted_2),
      _createElementVNode("input", {
        type: "hidden",
        name: "returnDate",
        value: _ctx.returnDate
      }, null, 8, _hoisted_3),
      _createElementVNode("input", {
        type: "hidden",
        name: "passengerTypes",
        value: _ctx.passengers
      }, null, 8, _hoisted_4),
      _createElementVNode("input", {
        type: "hidden",
        name: "voucher",
        value: _ctx.voucherCode
      }, null, 8, _hoisted_5),
      (_ctx.isMediumScreen)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_BaseDropdown, {
              modelValue: _ctx.v$.modeOfTravel.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.modeOfTravel.$model) = $event)),
              options: _ctx.typeOfTravel,
              insideLabel: "Mode of travel",
              name: "modeOfTravel",
              ref: "modeOfTravel",
              next: _ctx.leavingFrom,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open(_ctx.leavingFrom)))
            }, null, 8, ["modelValue", "options", "next"]),
            _createVNode(_component_QuickformPassengers),
            _createVNode(_component_BaseDropdown, {
              insideLabel: "Leaving from",
              modelValue: _ctx.from,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.from) = $event)),
              options: _ctx.outwardOptions,
              name: "leavingFrom",
              ref: "leavingFrom",
              next: _ctx.goingTo,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open(_ctx.goingTo)))
            }, null, 8, ["modelValue", "options", "next"]),
            _createVNode(_component_BaseDropdown, {
              insideLabel: "Going to",
              modelValue: _ctx.to,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.to) = $event)),
              options: _ctx.returnOptions,
              name: "goingTo",
              ref: "goingTo",
              next: _ctx.calendar,
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.open(_ctx.calendar)))
            }, null, 8, ["modelValue", "options", "next"]),
            _createVNode(_component_QuickformCalendar, {
              class: "full-width",
              ref: "calendar"
            }, null, 512),
            _createVNode(_component_QuickformDiscount, {
              class: "discount full-width",
              applyVoucher: _ctx.isExternal === false
            }, null, 8, ["applyVoucher"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BaseButton, { loading: _ctx.loading }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("Book now")
                ])),
                _: 1,
                __: [13]
              }, 8, ["loading"])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_BaseDropdown, {
              modelValue: _ctx.v$.modeOfTravel.$model,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.modeOfTravel.$model) = $event)),
              options: _ctx.typeOfTravel,
              insideLabel: "Mode of travel",
              name: "modeOfTravel",
              next: _ctx.leavingFrom,
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.open(_ctx.leavingFrom)))
            }, null, 8, ["modelValue", "options", "next"]),
            _createVNode(_component_BaseDropdown, {
              insideLabel: "Leaving from",
              modelValue: _ctx.from,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.from) = $event)),
              options: _ctx.outwardOptions,
              name: "leavingFrom",
              ref: "leavingFrom",
              next: _ctx.goingTo,
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.open(_ctx.goingTo)))
            }, null, 8, ["modelValue", "options", "next"]),
            _createVNode(_component_BaseDropdown, {
              insideLabel: "Going to",
              modelValue: _ctx.to,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.to) = $event)),
              options: _ctx.returnOptions,
              name: "goingTo",
              ref: "goingTo",
              next: _ctx.calendar,
              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.open(_ctx.calendar)))
            }, null, 8, ["modelValue", "options", "next"]),
            _createVNode(_component_QuickformCalendar, { ref: "calendar" }, null, 512),
            _createVNode(_component_QuickformPassengers),
            (_ctx.isSmallScreen)
              ? (_openBlock(), _createBlock(_component_QuickformDiscount, {
                  key: 0,
                  class: "discount full-width"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_BaseButton, { loading: _ctx.loading }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("Book now")
                ])),
                _: 1,
                __: [14]
              }, 8, ["loading"])
            ])
          ], 64))
    ], 40, _hoisted_1),
    (!_ctx.isMediumScreen && !_ctx.isSmallScreen)
      ? (_openBlock(), _createBlock(_component_QuickformDiscount, {
          key: 0,
          class: "discount full-width",
          applyVoucher: _ctx.isExternal === false
        }, null, 8, ["applyVoucher"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 0,
            type: "danger",
            message: _ctx.error
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}